import React from "react";
import { inr, fmtDate } from "../lib/format";
import { downloadNoticePDF } from "../lib/noticeExport";
import { Download } from "lucide-react";

export const DemandNotice = ({ invoice, calc, companyName }) => (
  <div className="bg-secondary p-6">
    <div className="max-w-2xl mx-auto mb-4 flex items-center justify-between">
      <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-muted-foreground">
        Generated draft · review before serving
      </span>
      <button
        data-testid="download-notice-btn"
        onClick={() => downloadNoticePDF(invoice, calc, companyName)}
        className="inline-flex items-center gap-2 bg-ink text-white text-sm font-medium px-4 py-2 hover:bg-black hover:-translate-y-[1px] transition-transform duration-150"
      >
        <Download className="h-4 w-4" strokeWidth={1.5} /> Download as PDF
      </button>
    </div>
    <div className="flex justify-center">
    <div
      data-testid="demand-notice"
      className="bg-white doc-shadow ring-1 ring-black/5 w-full max-w-2xl p-10 font-sans text-[13px] leading-relaxed text-ink"
    >
      <div className="flex items-start justify-between border-b border-ink pb-4">
        <div>
          <div className="font-serif text-xl font-semibold">DEMAND NOTICE</div>
          <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-1">
            Under Section 16, MSMED Act, 2006
          </div>
        </div>
        <div className="text-right font-mono text-[11px] text-muted-foreground">
          <div>Ref: BAAKI/{invoice.id}</div>
          <div>Date: {fmtDate("2025-06-15")}</div>
        </div>
      </div>

      <div className="mt-5 space-y-1">
        <div className="font-mono text-[11px] uppercase tracking-wider text-muted-foreground">To,</div>
        <div className="font-medium">{invoice.buyer}</div>
        <div className="text-muted-foreground">(Buyer / Purchaser — {invoice.buyerType})</div>
      </div>

      <p className="mt-5">
        <span className="font-medium">Subject:</span> Demand for payment of{" "}
        <span className="font-mono">{inr(invoice.principal)}</span> together with statutory
        interest for goods supplied / services rendered vide Invoice No.{" "}
        <span className="font-mono">{invoice.id}</span> dated{" "}
        {fmtDate(invoice.invoiceDate)}.
      </p>

      <p className="mt-4">
        Our client, a Micro / Small Enterprise duly registered under the Udyam Registration
        framework, supplied goods / rendered services which were accepted by you on{" "}
        {fmtDate(invoice.acceptanceDate)}. As per Section 15 of the MSMED Act, 2006, payment
        was due within the appointed day, not exceeding <span className="font-medium">45 days</span>{" "}
        from the day of acceptance, i.e. on or before{" "}
        <span className="font-mono">{fmtDate(calc.due)}</span>.
      </p>

      <p className="mt-4">
        Despite the said period having elapsed, the principal amount remains unpaid for{" "}
        <span className="font-mono">{calc.daysOverdue}</span> days. Consequently, under
        Section 16, you are liable to pay compound interest with monthly rests at three times
        the Bank Rate notified by the Reserve Bank of India.
      </p>

      <div className="mt-5 border border-border">
        <table className="w-full font-mono text-[12px]">
          <tbody>
            <tr className="border-b border-border">
              <td className="px-3 py-2">Principal outstanding</td>
              <td className="px-3 py-2 text-right">{inr(invoice.principal)}</td>
            </tr>
            <tr className="border-b border-border">
              <td className="px-3 py-2">Statutory interest (§16)</td>
              <td className="px-3 py-2 text-right">{inr(calc.totalInterest)}</td>
            </tr>
            <tr className="bg-secondary">
              <td className="px-3 py-2 font-semibold">Total amount demanded</td>
              <td className="px-3 py-2 text-right font-semibold">{inr(calc.grandTotal)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="mt-5">
        You are hereby called upon to pay the aforesaid sum within{" "}
        <span className="font-medium">fifteen (15) days</span> of receipt of this notice,
        failing which our client shall be constrained to refer the dispute to the Micro and
        Small Enterprises Facilitation Council (MSEFC) via the Samadhaan portal under Section
        18, and pursue all remedies available in law, entirely at your risk as to cost and
        consequence.
      </p>

      <div className="mt-8 flex items-end justify-between">
        <div>
          <div className="font-medium">For and on behalf of {companyName || "the Supplier"}</div>
          <div className="text-muted-foreground text-xs">(Authorised Signatory)</div>
        </div>
      </div>

      <div className="mt-8 border-t border-border pt-3">
        <p className="font-mono text-[9px] uppercase tracking-[0.16em] text-muted-foreground leading-relaxed">
          Informational tool, not legal advice. This draft is generated for demonstration and
          must be reviewed by a qualified advocate before service. KashBaaki does not constitute an
          advocate–client relationship.
        </p>
      </div>
    </div>
    </div>
  </div>
);
